import React, { useState } from "react";

const Blog_Lead = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    const { name, email } = formData;

    if (!name || !email) {
      setErrorMessage("Please enter both your name and email.");
      return;
    }

    setLoading(true);

    const requestBody = {
      Name: name,
      Email: email,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_DOMAIN}create-news-letter-zoho-api`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const result = await response.json();

      if (result?.ResponseCode === "1") {
        setSuccessMessage("Thanks! We'll be in touch soon.");
        setFormData({ name: "", email: "" }); // Clear fields
      } else {
        setErrorMessage(
          result?.ResponseText || "Submission failed. Please try again."
        );
      }
    } catch (err) {
      setErrorMessage("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="Blog-Leadmagnet">
      <div className="discount-image">
        <img src="../assets/images/Blog/discount50.webp" alt="Discount 50%" />
      </div>

      <p>Everything you need to run your business from your mobile phone.</p>

      <form className="NewsLetter" onSubmit={handleSubmit}>
        <div className="NewsLetter__field">
          <input
            type="text"
            id="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        <div className="NewsLetter__field">
          <input
            type="email"
            id="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <button
          type="submit"
          className="Blog-Leadmagnet__button"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Subscribe"}
        </button>

        {successMessage && <p className="success-message">{successMessage}</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </form>
    </section>
  );
};

export default Blog_Lead;
